import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse, IUserGroup } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'

const resource = 'usergroups'

const getAll = (axios: IFactoryFunctionRequest<any, undefined>) => ({ firmId }: { firmId: string }): IFactoryResponse<Array<IUserGroup>, undefined> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/${firmId}`,
  })
}

const getFilter = (axios: IFactoryFunctionRequest<Array<Pick<IUserGroup, '_id' | 'display'>>, undefined>) => (options = {}) => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/firm/filter`,
    query: options,
  })
}

// router.get('/paginate', auth.isAuth(), controller.paginate);
const getPaginated = (axios: IFactoryFunctionRequest<Array<Pick<IUserGroup, '_id' | 'display'>>, undefined>) => (options = {}) => {
  const route = options.firmId ? `firm/${options.firmId}/filter` : 'filter'
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${route}`,
    query: options,
  })
}

const create = (axios: IFactoryFunctionRequest<IUserGroup, Partial<IUserGroup>>) => (data: Partial<IUserGroup>) => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const update = (axios: IFactoryFunctionRequest<IUserGroup, Partial<IUserGroup>>) => (id: string, data: Partial<IUserGroup>) => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/${id}`,
    data,
  })
}


export default (axios: AxiosInstance) => ({
  getAll: getAll(useAxios(axios)),
  getFilter: getFilter(useAxios(axios)),
  getPaginated: getPaginated(useAxios(axios)),
  create: create(useAxios(axios)),
  update: update(useAxios(axios)),
})
